import { Component } from '@angular/core';

declare var require: any;
/*
@Component({
    selector: 'ahura-about',
    template: require('./about.component.html')
}) */
export class AboutComponent{

    static get annotations() {
        return [
            new Component({
                selector: 'ahura-about',
                template: require('./about.component.html')
            }),
        ];
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/core/components/about/about.component.ts